import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";

import "./index.css";
import "./i18n";
// TODO: Uncomment when AWS resources are configured
import "./config/amplifyConfig.ts";
import App from "./App.tsx";

const sentryDsn = import.meta.env.VITE_SENTRY_DSN;

if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        blockAllMedia: false,
      })
    ],
    tracesSampleRate: 0.5,
    tracePropagationTargets: ["localhost", "test.factors.analyticalplatform.com", "factors.analyticalplatform.com"],
    sendDefaultPii: true,
    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0
  });
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
